const Model = {

  company(){
    return {
      "type": "company",
      "flagswiftfx" : "",
      "currency": "gbp",
      "accountnumber": "",
      "sortcode": "",
      "iban": "",
      "bic": "",
      "del": false,
      "company": {
        "region": "",
        "countrycode": "",
        "zipcode": "",
        "addressnumber": "",
        "refinement": "",
        "street": "",
        "city": "",
        "regulateFinancial": false,
        "registrationNumber": "",
        "email": "",
        "natureofbusiness": "",
        "webSite": "",
        "name": "",
        "tradingName": "",
        "telephone": "",
        "typeOfBusiness": "",
        "tradingAddress": {
          "region": "",
          "countrycode": "",
          "zipcode": "",
          "addressnumber": "",
          "refinement": "",
          "street": "",
          "city": ""
        }
      },
      "director": {
        "pep": false,
        "pepType": "",
        "pepNotes": "",
        "position": "",
        "approvedate": "",
        "identifyNumber": "",
        "identifyType": "",
        "identifyExpire": "",
        "email": "",
        "name": "",
        "telephone": "",
        "dateOfBirth": "",
        "nationality": "",
        "residentCountry": ""
      }
    }
  },

  person(){
    return {
      "type": "person",
      "flagswiftfx" : "",
      "currency": "gbp",
      "accountnumber": "",
      "sortcode": "",
      "iban": "",
      "bic": "",
      "del": false,
      "personal": {
        "region": "",
        "countrycode": "",
        "zipcode": "",
        "addressnumber": "",
        "refinement": "",
        "street": "",
        "city": "",
        "pep": false,
        "pepType": "",
        "pepNotes": "",
        "approvedate": "",
        "identifyNumber": "",
        "identifyType": "",
        "identifyExpire": "",
        "email": "",
        "name": "",
        "telephone": "",
        "dateOfBirth": "",
        "nationality": "",
        "residentCountry": ""
      }
    }
  },

  currency: {
    domistic: ["GBP", "EUR"],
    international:["GBP", "EUR", "USD", "NOK", "JPY", "NZD", "SEK", "CHF", "AUD", "SGD"]
  },


  companyRule: {
    "accountnumber": [
      {
        required: true,
        message: "Please enter Account Number",
        trigger: "blur",
      },
    ],
    "sortcode": [
      {
        required: true,
        message: "Please enter Sortcode",
        trigger: "blur",
      },
    ],
    "iban": [
      {
        required: true,
        message: "Please enter IBAN",
        trigger: "blur",
      },
    ],
    "bic": [
      {
        required: true,
        message: "Please enter BIC",
        trigger: "blur",
      },
    ],
    "company": {
      "region": [
        {
          required: true,
          message: "Please enter Region",
          trigger: "blur",
        },
      ],
      "countrycode": [
        {
          required: true,
          message: "Please enter Country code",
          trigger: "blur",
        },
      ],
      "zipcode": [
        {
          required: true,
          message: "Please enter Zipcode",
          trigger: "blur",
        },
      ],
      "addressnumber": [
        {
          required: true,
          message: "Please enter Address number",
          trigger: "blur",
        },
      ],
      "street": [
        {
          required: true,
          message: "Please enter Sreet",
          trigger: "blur",
        },
      ],
      "city": [
        {
          required: true,
          message: "Please enter City",
          trigger: "blur",
        },
      ],
      "registrationNumber": [
        {
          required: true,
          message: "Please enter Registration Number",
          trigger: "blur",
        },
      ],
      "email": [
        {
          required: true,
          message: "Please enter Email",
          trigger: "blur",
        },
      ],
      "natureofbusiness": [
        {
          required: true,
          message: "Please enter Nature of business",
          trigger: "blur",
        },
      ],
      "webSite": [
        {
          required: true,
          message: "Please enter Web site",
          trigger: "blur",
        },
      ],
      "name": [
        {
          required: true,
          message: "Please enter Name",
          trigger: "blur",
        },
      ],
      "tradingName": [
        {
          required: true,
          message: "Please enter City",
          trigger: "blur",
        },
      ],
      "telephone": [
        {
          required: true,
          message: "Please enter Telephone",
          trigger: "blur",
        },
      ],
      "typeOfBusiness": [
        {
          required: true,
          message: "Please enter City",
          trigger: "blur",
        },
      ],
      "tradingAddress": {
        "region": [
          {
            required: true,
            message: "Please enter Region",
            trigger: "blur",
          },
        ],
        "countrycode": [
          {
            required: true,
            message: "Please enter Country code",
            trigger: "blur",
          },
        ],
        "zipcode": [
          {
            required: true,
            message: "Please enter Zipcode",
            trigger: "blur",
          },
        ],
        "addressnumber": [
          {
            required: true,
            message: "Please enter Address number",
            trigger: "blur",
          },
        ],
        "street": [
          {
            required: true,
            message: "Please enter Sreet",
            trigger: "blur",
          },
        ],
        "city": [
          {
            required: true,
            message: "Please enter City",
            trigger: "blur",
          },
        ]
      }
    },
    "director": {
      "pepType": [
        {
          required: true,
          message: "Please enter Pep Type",
          trigger: "blur",
        },
      ],
      "pepNotes": [
        {
          required: true,
          message: "Please enter Pep Notes",
          trigger: "blur",
        },
      ],
      "position": [
        {
          required: true,
          message: "Please enter Position",
          trigger: "blur",
        },
      ],
      "identifyNumber": [
        {
          required: true,
          message: "Please enter Identify Number",
          trigger: "blur",
        },
      ],
      "identifyType": [
        {
          required: true,
          message: "Please enter Identify Type",
          trigger: "blur",
        },
      ],
      "identifyExpire": [
        {
          required: true,
          message: "Please enter Identify Expire",
          trigger: "blur",
        },
      ],
      "email": [
        {
          required: true,
          message: "Please enter Email",
          trigger: "blur",
        },
      ],
      "name": [
        {
          required: true,
          message: "Please enter Director Name",
          trigger: "blur",
        },
      ],
      "telephone": [
        {
          required: true,
          message: "Please enter Telephone",
          trigger: "blur",
        },
      ],
      "dateOfBirth": [
        {
          required: true,
          message: "Please enter Date Of Birth",
          trigger: "blur",
        },
      ],
      "nationality": [
        {
          required: true,
          message: "Please enter Nationality",
          trigger: "blur",
        },
      ],
      "residentCountry": [
        {
          required: true,
          message: "Please enter Resident Country",
          trigger: "blur",
        },
      ]
    }
  },

  personRule:{
    "accountnumber": [
      {
        required: true,
        message: "Please enter Account Number",
        trigger: "blur",
      },
    ],
    "sortcode": [
      {
        required: true,
        message: "Please enter Sortcode",
        trigger: "blur",
      },
    ],
    "iban": [
      {
        required: true,
        message: "Please enter IBAN",
        trigger: "blur",
      },
    ],
    "bic": [
      {
        required: true,
        message: "Please enter BIC",
        trigger: "blur",
      },
    ],
    "personal": {
      "region": [
        {
          required: true,
          message: "Please enter Region",
          trigger: "blur",
        },
      ],
      "countrycode": [
        {
          required: true,
          message: "Please enter Country code",
          trigger: "blur",
        },
      ],
      "zipcode": [
        {
          required: true,
          message: "Please enter Zipcode",
          trigger: "blur",
        },
      ],
      "addressnumber": [
        {
          required: true,
          message: "Please enter Address number",
          trigger: "blur",
        },
      ],
    
      "street": [
        {
          required: true,
          message: "Please enter Sreet",
          trigger: "blur",
        },
      ],
      "city": [
        {
          required: true,
          message: "Please enter City",
          trigger: "blur",
        },
      ],
      "pepType": [
        {
          required: true,
          message: "Please enter Pep Type",
          trigger: "blur",
        },
      ],
      "pepNotes": [
        {
          required: true,
          message: "Please enter Pep Notes",
          trigger: "blur",
        },
      ],
 
      "identifyNumber": [
        {
          required: true,
          message: "Please enter Identify Number",
          trigger: "blur",
        },
      ],
      "identifyType": [
        {
          required: true,
          message: "Please enter Identify Type",
          trigger: "blur",
        },
      ],
      "identifyExpire": [
        {
          required: true,
          message: "Please enter Identify Expire",
          trigger: "blur",
        },
      ],
      "email": [
        {
          required: true,
          message: "Please enter Email",
          trigger: "blur",
        },
      ],
      "name": [
        {
          required: true,
          message: "Please enter Name",
          trigger: "blur",
        },
      ],
      "telephone": [
        {
          required: true,
          message: "Please enter Telephone",
          trigger: "blur",
        },
      ],
      "dateOfBirth": [
        {
          required: true,
          message: "Please enter Date Of Birth",
          trigger: "blur",
        },
      ],
      "nationality": [
        {
          required: true,
          message: "Please enter Nationality",
          trigger: "blur",
        },
      ],
      "residentCountry": [
        {
          required: true,
          message: "Please enter Resident Country",
          trigger: "blur",
        },
      ]
    }
  }
   
}

export default  Model